import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = {
  key: 11,
  class: "environment"
}
const _hoisted_3 = {
  key: 12,
  class: "version"
}

export function render(_ctx, _cache) {
  const _component_Menu = _resolveComponent("Menu")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_DataAnalysis = _resolveComponent("DataAnalysis")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_Box = _resolveComponent("Box")
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")
  const _component_Files = _resolveComponent("Files")
  const _component_Memo = _resolveComponent("Memo")
  const _component_Compass = _resolveComponent("Compass")
  const _component_Collection = _resolveComponent("Collection")
  const _component_ChatLineRound = _resolveComponent("ChatLineRound")
  const _component_Tickets = _resolveComponent("Tickets")
  const _component_GoldMedal = _resolveComponent("GoldMedal")
  const _component_Suitcase = _resolveComponent("Suitcase")
  const _component_User = _resolveComponent("User")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      class: "el-menu-vertical",
      "active-text-color": "#ffffff",
      "bg-color": "#ffffff",
      "text-color": "#00000088",
      "default-active": _ctx.activeMenu,
      collapse: _ctx.isCollapsed,
      "collapse-transition": false,
      onSelect: _ctx.handleSelect
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "el-menu-item",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onMenuClick && _ctx.onMenuClick(...args)))
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Menu)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_menu_item, {
          index: _ctx.NavigationIndex.DASHBOARD,
          class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.DASHBOARD ? 'active' : '')
        }, {
          title: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Übersicht")
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_DataAnalysis)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["index", "class"]),
        (_ctx.hasPermission['SOUR_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: _ctx.NavigationIndex.SOURCE,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.SOURCE ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Quellen")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Box)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CUST_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: _ctx.NavigationIndex.CUSTOMER,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.CUSTOMER ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Mandant")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_OfficeBuilding)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CLNT_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 2,
              index: _ctx.NavigationIndex.CLIENT,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.CLIENT ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Ämter")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Files)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CATG_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 3,
              index: _ctx.NavigationIndex.CATEGORY,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.CATEGORY ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Kategorien")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Memo)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['TARG_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 4,
              index: _ctx.NavigationIndex.TARGETGROUP,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.TARGETGROUP ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Zielgruppen")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Compass)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['REFN_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 5,
              index: _ctx.NavigationIndex.REFERENCE,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.REFERENCE ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Referenzen")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Collection)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['QSTN_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 6,
              index: _ctx.NavigationIndex.QUESTION,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.QUESTION ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Fragenkatalog")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ChatLineRound)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['TKLS_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 7,
              index: _ctx.NavigationIndex.TICKETLIST,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.TICKETLIST ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Ticketlisten")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Tickets)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['TEST_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 8,
              index: _ctx.NavigationIndex.TEST,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.TEST ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Prüfungen")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_GoldMedal)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['ROLE_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 9,
              index: _ctx.NavigationIndex.ROLE,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.ROLE ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Rollen")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Suitcase)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['USER_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 10,
              index: _ctx.NavigationIndex.USER,
              class: _normalizeClass(_ctx.activeMenu == _ctx.NavigationIndex.USER ? 'active' : '')
            }, {
              title: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Benutzer")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_User)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : _createCommentVNode("", true),
        (_ctx.windowHeight > 620)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.environmentName), 1))
          : _createCommentVNode("", true),
        (_ctx.windowHeight > 620)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " V. " + _toDisplayString(_ctx.environmentVersion), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["default-active", "collapse", "onSelect"])
  ]))
}